import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { z } from 'zod'

interface ZodPhoneNumberOptions {
  required?: boolean
}

export function zPhoneNumber(options?: ZodPhoneNumberOptions) {
  return z
    .string()
    .nullish()
    .transform((value, ctx) => {
      if (value?.trim()) {
        const phoneNumber = parsePhoneNumberFromString(value, {
          defaultCountry: 'US',
          extract: false,
        })

        // +1 only: formatNational() drops the country code, so the backend reads every number as +1.
        if (phoneNumber?.isValid() && phoneNumber.countryCallingCode === '1') {
          return phoneNumber.formatNational()
        }

        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Invalid phone number',
        })
      } else if (options?.required) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Phone number is required',
        })
      }

      return value
    })
}
